export const speechInstance = state => state.speechInstance
export const reading = state => state.reading
export const paused = state => state.paused
export const availableVoices = state => state.availableVoices
export const playlist = state => state.playlist

export const activePlaylist = state => {
  return state.currentPoiId !== -1
}

export const currentIndex = state => state.currentIndex

export const playlistSubtitle = state => {
  const item = state.playlist[state.currentIndex]
  return item ? item.subtitle : ''
}
export const playlistProgress = state => {
  if (!state.playlist.length) return 0
  else {
    if (state.currentIndex + 1 === state.playlist.length) return 100
    else return Math.round((state.currentIndex + 1) / state.playlist.length * 100)
  }
}
export const currentText = state => {
  if (state.currentIndex > -1) return state.currentText
  else return ''
}
export const markerSpeech = state => state.markerSpeech

// to replace
// export const playlistTitle = state => state.playlistTitle
export const playlistTitle = state => {
  if (!state.markerSpeech) return ''
  else return state.markerSpeech.title
}
// export const currentPoiId = state => state.currentPoiId
export const currentPoiId = state => {
  if (!state.markerSpeech) return null
  else return state.markerSpeech._id
}
